import { render, staticRenderFns } from "./SmsSalesSlip.vue?vue&type=template&id=1f0a0210"
import script from "./SmsSalesSlip.vue?vue&type=script&lang=js"
export * from "./SmsSalesSlip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports